<!-- 前端导出Excel组件 -->
<template>
  <el-button :type="type"
             :size="size"
             :icon="icon"
             @click="handleDownload"
             :loading="loading"><span v-if="!circle && buttonName">{{ buttonName }}</span>
  </el-button>
</template>
<script>
/**
 * @desc 台账导出
 * @param config {} 必传配置项
 *-- @param url { String }  查询导出数据请求地址
 *-- @param ColumnData { Array }  表格配置数据
 *------- @param  ColumnData.exportProp  映射到后台的真实字段。因考虑转义问题 前后台可能都有不一样的处理提供方式覆盖 如 prop: "mineCode", ==> exportProp: 'mineCodeName',        
 *-- @param  buttonName { String } 按钮名称
 *-- @param  icon { String } 按钮图标
 *-- @param  size { String } 按钮尺寸
 *-- @param  circle { boolean } 是否圆形按钮	
  @param downloadQuery  列表查询的query对象。必须保证和query同源且不能改变原有浅拷贝（堆）
  @param FileName 下载文件的名字
  @param customQuery 自定义传参（downloadQuery内没有的字段）
 **/
import { getRequset } from "@/basic-common/util/common.js";
import { dayNowFn, getDateRange } from "@/util/date.js";

export default {
  name: "ExportByPageJson",
  props: {
    config: {
      type: Object,
      required: true,
    },
    downloadQuery: {
      type: Object,
      required: true,
    },
    FileName: {
      type: String,
      required: true,
      default: "下载内容",
    },
    customQuery: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      type: "",
      size: "small",
      icon: "el-icon-download",
      buttonName: "导出Excel",
      ...this.config,
      loading: false,
      updateKey: false,
      columnData_: []
    };
  },
  watch: {
    'config.ColumnData': {
      handler(newData) {
        this.columnData_ = newData
      }
    },
  },
  methods: {
    async handleDownload() {
      this.$confirm_primary("导出").then(() => {
        this.loading = true;
        // 因源码无法在业务层影响 手动点击同步查询条件
        const headerquery =
          document.querySelector(".avue-group--header") || null;
        const btn = headerquery ? headerquery.querySelector("button") : null;
        const clickEvent = document.createEvent("MouseEvents");
        clickEvent.initEvent("click", false, false);
        btn && btn.dispatchEvent(clickEvent);
        this.$message({
          type: "success",
          message: "正在导出，可能会因数据量过大处理时间较长 请耐心等候",
          duration: "4500",
        });
        // 因执行函数阻塞与父组件执行函数查询之后 获取不到最新的query setTimeout延时
        setTimeout(() => {
          let query = { ...this.downloadQuery, ...this.customQuery };
          // 时间段都为空时默认一个月
          // TODO  如果除计量以外有功能需要使用  此部分代码后续应该抽走或删除
          if (!query.searchDate) {
            query.searchDate = `${getDateRange(new Date(), 30, true)[0]},${getDateRange(new Date(), 30, true)[1]
              }`;
            this.$message({
              message: "温馨提示：时间检索选项置空，会默认导出近一个月的数据",
              type: "warning",
              duration: "5500",
            });
            // 时间段有大于一个月拒绝导出
          } else if (this.DateGaps(query.searchDate)) {
            this.loading = false;
            return this.$message({
              message:
                "拒绝导出，时间范围检索仅支持选择一个月，如果你想检索近一个月的数据请置空时间选项",
              type: "warning",
              duration: "5500",
            });
          }
          if (!(typeof this.config.url == "string")) {
            return this.DownloadExcel(this.config.url);
          }
          // 查询数据
          getRequset(this.config.url, query)
            .then(({ data: { data } }) => {
              // 调用导出
              this.DownloadExcel(data);
            })
            .catch(() => {
              this.loading = false;
              this.$message({
                message: "查询数据失败导致无法导出，系统将不会下载任何内容",
                type: "warning",
                duration: "5500",
              });
            });
        });
      });
    },
    // 导出处理
    DownloadExcel(resdata) {
      resdata = resdata.records || resdata;
      if (!resdata.length) {
        this.loading = false;
        return this.$message({
          message: "执行成功，但未查询到需要导出的数据，系统将不会下载任何内容",
          type: "warning",
          duration: "5000",
        });
      }

      // 处理数据
      let tHeader = [];
      let filterVal = [];
      this.columnData_.map((item) => {
        if (!item.hide) {
          tHeader.push(item.label);
          // 处理转义不同的字段
          const itemProp = item.exportProp || item.prop;
          filterVal.push(itemProp);
        }
      });
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/util/vendor/Export2Excel");
        const data = this.formatJson(filterVal, resdata);
        export_json_to_excel(tHeader, data, this.FileName + "  " + dayNowFn());
        this.$emit("update:key", this.updateKey);
        this.updateKey = !this.updateKey;
        this.loading = false;
      });
      setTimeout(() => {
        this.$message({
          type: "success",
          message: "导出成功,正在下载",
        });
      }, 500);
    },
    // 清洗数据
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 判断时间段是否超过一个月    //  true表示大于一个月
    DateGaps(datas) {
      if (!datas) {
        return false;
      }
      let sDate = new Date(datas.split(",")[0]);
      let eDate = new Date(datas.split(",")[1]);
      if (eDate.getFullYear() - sDate.getFullYear() > 1) {
        return true;
      } else if (eDate.getMonth() - sDate.getMonth() > 1) {
        return true;
      } else if (eDate.getMonth() - sDate.getMonth() == 1) {
        if (eDate.getDate() - sDate.getDate() >= 1) {
          return true;
        }
      } else if (eDate.getFullYear() - sDate.getFullYear() == 1) {
        if (eDate.getMonth() + 12 - sDate.getMonth() > 1) {
          return true;
        } else if (eDate.getDate() - sDate.getDate() >= 1) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
